<template>
    <v-container>
        <v-btn
                @click="newCovid" large color="primary">Nuevo
        </v-btn>
        <v-layout>
            <v-flex>
                <div>
                    <v-layout>
                        <v-flex xs12 sm6 offset-sm6>
                            <v-text-field
                                    v-model="$store.state.covidFichaSearch"
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>
            <v-dialog
                    v-model="dialog"
                    fullscreen hide-overlay transition="dialog-bottom-transition"
                    scrollable>
                <v-card tile>
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Registro COVID</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm10 offset-sm1>
                                    <v-text-field
                                            name="identification"
                                            label="Identificación"
                                            id="identification"
                                            :rules="[v => !!v || 'La identificación es requerida', v => (v && v.length <= 15) || 'El valor debe tener menos de 15 caracteres']"
                                            @blur="getLastCovidRegister"
                                            required
                                            v-model="covid.identification"
                                    ></v-text-field>
                                    <v-text-field
                                            name="email"
                                            label="Email"
                                            id="email"
                                            :rules="[v => !!v || 'El email es requerido', v => (v && v.length <= 200) || 'El número de caracteres debe ser menor a 200']"
                                            v-model="covid.email"
                                            required
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-expansion-panel v-if="covid!=null">
                                <v-expansion-panel-content v-for="item in covid.lista" v-bind:key="item.id">
                                    <template v-slot:header>
                                        <div>{{item.encabezado}}</div>
                                    </template>
                                    <div v-if="item.img === 'img5' || item.img === 'img6'" class="text-xs-center">
                                        <v-btn
                                                color="primary"
                                                dark
                                                @click="showImageDialog(item.img)"
                                        >
                                            Ver ayuda
                                        </v-btn>
                                    </div>
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <v-data-table
                                                    :items="item.datos"
                                                    class="elevation-1"
                                                    hide-actions
                                                    hide-headers
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <td class="text-xs-left">
                                                        <p v-if="props.item.tipo==0" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <p v-if="props.item.tipo==1" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-select
                                                                v-if="props.item.tipo==1"
                                                                :items="props.item.data"
                                                                v-model="props.item.valor"
                                                                :style="props.item.color"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                required
                                                        ></v-select>
                                                        <p v-if="props.item.tipo==2" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-select
                                                                v-if="props.item.tipo==2"
                                                                :items="props.item.data"
                                                                v-model="props.item.valor"
                                                                @change="props.item.valor2=''"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                required
                                                        ></v-select>
                                                        <v-text-field
                                                                v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2==null && props.item.label3==null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre') "
                                                                :label="props.item.label2"
                                                                v-model="props.item.valor2"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                :required="props.item.validate==null?true:false"
                                                        ></v-text-field>
                                                        <v-select
                                                                v-if="props.item.tipo==2 && props.item.label2!=null && props.item.data2!=null && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI'||props.item.valor=='Femenino'||props.item.valor=='A veces'||props.item.valor=='Siempre')"
                                                                :label="props.item.label2"
                                                                :items="props.item.data2"
                                                                v-model="props.item.valor2"
                                                                @change="props.item.valor3=''"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                required
                                                        ></v-select>
                                                        <v-text-field
                                                                v-if="props.item.tipo==2 && props.item.valor3==null && (props.item.valor2=='Otros medios'||props.item.valor2=='Otros' ||props.item.valor2=='Otro'|| props.item.valor2=='SI'||props.item.valor2=='Femenino') "
                                                                :label="props.item.label3"
                                                                v-model="props.item.valor3"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                :required="props.item.validate==null?true:false"
                                                        ></v-text-field>
                                                        <p v-if="props.item.tipo==3" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-text-field
                                                                v-if="props.item.tipo==3"
                                                                v-model="props.item.descripcion"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                required
                                                        ></v-text-field>
                                                        <p v-if="props.item.tipo==4" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-textarea
                                                                v-if="props.item.tipo==4"
                                                                v-model="props.item.descripcion"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                required
                                                        ></v-textarea>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==5"
                                                                v-model="props.item.valor"
                                                                :label="props.item.label"
                                                        ></v-checkbox>
                                                        <v-text-field
                                                                v-if="props.item.tipo==5 && props.item.valor==true && item.encabezado!='1. Información personal y laboral'"
                                                                :label="props.item.label3"
                                                                v-model="props.item.valor3"
                                                                :rules="[v => !!v || 'El campo es requerido']"
                                                                :required="props.item.validate==null?true:false"
                                                        ></v-text-field>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor1"
                                                                label="Observación"
                                                                @change="changeStatus(1)"
                                                        ></v-checkbox>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor2"
                                                                label="Confirmado"
                                                                @change="changeStatus(2)"
                                                        ></v-checkbox>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor3"
                                                                label="Hospìtalizado"
                                                                @change="changeStatus(3)"
                                                        ></v-checkbox>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor4"
                                                                label="Recuperado"
                                                                @change="changeStatus(4)"
                                                        ></v-checkbox>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor5"
                                                                label="Fallecido"
                                                                @change="changeStatus(5)"

                                                        ></v-checkbox>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==6"
                                                                v-model="props.item.valor6"
                                                                label="Descartado"
                                                                @change="changeStatus(6)"

                                                        ></v-checkbox>
                                                        <v-select v-if="props.item.tipo==7"
                                                                  v-model="props.item.valor"
                                                                  :items="$store.state.companies"
                                                                  item-value="id"
                                                                  item-text="name"
                                                                  :rules="[v => !!v || 'Cliente es requerido']"
                                                                  label="Cliente"
                                                                  return-object
                                                                  persistent-hint
                                                                  required
                                                        ></v-select>
                                                        <v-checkbox
                                                                v-if="props.item.tipo==8"
                                                                v-model="props.item.valor"
                                                                :label="props.item.label"
                                                        ></v-checkbox>
                                                        <v-select
                                                                v-if="props.item.tipo==9"
                                                                :items="props.item.data"
                                                                :label="props.item.label"
                                                                v-model="props.item.valor"
                                                        ></v-select>
                                                        <v-text-field
                                                                v-if="props.item.tipo==10"
                                                                :label="props.item.label"
                                                                v-model="props.item.valor"
                                                        ></v-text-field>
                                                        <p v-if="props.item.tipo==12" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-select
                                                                v-if="props.item.tipo==12"
                                                                :items="props.item.data"
                                                                v-model="props.item.valor"
                                                        ></v-select>
                                                        <v-text-field
                                                                v-if="props.item.tipo==12 && (props.item.valor=='Otros medios'||props.item.valor=='Otros' || props.item.valor=='SI') "
                                                                :label="props.item.label2"
                                                                v-model="props.item.valor2"
                                                        ></v-text-field>

                                                        <p v-if="props.item.tipo==13" class="font-weight-bold">
                                                            {{props.item.label}}</p>
                                                        <v-text-field
                                                                v-if="props.item.tipo==13"
                                                                v-model="props.item.valor"
                                                                @keypress="permitOnlyNumbers($event)"
                                                        ></v-text-field>
                                                    </td>
                                                </template>
                                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                                    No se han encontrado resultados para "{{ search }}".
                                                </v-alert>
                                            </v-data-table>
                                        </v-flex>
                                    </v-layout>
                                </v-expansion-panel-content>
                                <v-expansion-panel-content>
                                    <template v-slot:header>
                                        <div>Ubicación</div>
                                    </template>
                                    <v-layout>
                                        <v-flex xs12 sm10 offset-sm1>
                                            <div id="map"></div>
                                        </v-flex>
                                    </v-layout>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-form>
                        <div class="text-xs-center" v-if="covid!=null">
                            <v-btn color="primary" @click="saveData" dark>Guardar</v-btn>
                        </div>
                        <div class="text-xs-center">
                            <v-dialog
                                    v-model="dialogImg"
                                    fullscreen hide-overlay transition="dialog-bottom-transition"
                            >
                                <v-card tile>
                                    <v-toolbar card dark color="nav_background_color">
                                        <v-btn icon dark @click.native="dialogImg = false">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                        <v-toolbar-title>Ayuda</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-spacer></v-spacer>
                                    <v-card-text>
                                        <div class="text-xs-center">
                                            <img v-if="imagePath == 'img5'" src="../../assets/punto_5.jpeg">
                                            <img v-if="imagePath == 'img6'" src="../../assets/punto_6.jpg">
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </div>
                    </v-card-text>
                    <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog>
        </v-layout>
        <h3 class="primary--text">Lista de Registros de Covid</h3>
        <v-data-table
                :headers="headers"
                :items="this.covidListSearch"
                class="elevation-1"
                sort-icon="mdi-menu-down"
                :search="$store.state.covidFichaSearch"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.identificacion }}</td>
                <td class="text-xs-left">{{ props.item.codigoUnico }}</td>
                <td class="text-xs-left">{{ props.item.nombre }}</td>
                <td class="text-xs-left">{{ props.item.telefono }}</td>
                <td class="text-xs-left">{{ props.item.empresa }}</td>
                <td class="text-xs-left">{{ props.item.fecha }}</td>

                <td>
                    <a @click="editItem(props.item)">Ver Resultados</a>
                </td>
                <td>
                    <a @click="getCovidTracer(props.item)">Ver Seguimiento</a>
                </td>
                <td>
                    <v-tooltip top>
                        <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                            <v-icon dark>delete</v-icon>
                        </v-btn>
                        <span>Eliminar</span>
                    </v-tooltip>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se han encontrado resultados para "{{ $store.state.covidFichaSearch }}".
            </v-alert>
        </v-data-table>
        <v-layout>
            <v-flex
                    xs12
                    md12
            >
                <table>
                    <td>
                        <download-excel :fetch="getCovidReport"
                                        style="width:200px"
                                        name="reporte_ficha.xls">
                            <v-btn small color="primary">
                                Reporte de ficha
                                <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                        </download-excel>
                    </td>
                    <td>
                        <download-excel :fetch="getCovidTraceReport"
                                        style="width:200px"
                                        name="reporte_seguimientos.xls">
                            <v-btn small color="secondary">
                                Reporte seguimientos
                                <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                        </download-excel>
                    </td>
                </table>
            </v-flex>
        </v-layout>
        <v-dialog
                v-model="dialogErrorExist"
                max-width="500px"
        >
            <v-card>
                <v-card-title>
                    <span>Por favor ingrese los campos requeridos.</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            text
                            @click="dialogErrorExist = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
    import Covid from "../../model/Covid";
    import CovidEntity from "../../model/CovidEntity";
    import mapboxgl from 'mapbox-gl'
    import CovidConfiguration from "../../model/CovidConfiguration";

    const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
    const sha = require('js-sha256');
    export default {
        data() {
            return {
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
                headers: [
                    {text: 'Identificación', value: 'identificacion'},
                    {text: 'Código Único', value: 'codigoUnico'},
                    {text: 'Nombre', value: 'nombre'},
                    {text: 'Teléfono', value: 'telefono'},
                    {text: 'Empresa', value: 'empresa'},
                    {text: 'Fecha', value: 'fecha'},
                    {text: 'Resultado', value: 'actions'},
                    {text: 'Seguimiento', value: 'seguimiento'},
                    {text: 'Eliminar', value: 'seguimiento'}
                ],
                editedIndex: -1,
                covid: new Covid(),
                covidEntity: {},
                covidList: [],
                covidListSearch: [],
                access_token:
                    'pk.eyJ1IjoiYWZjb21wdWVjdWFkb3IiLCJhIjoiY2s4dndpcTBnMHFsOTNmbWhmMDlibmE3ayJ9.PRgXLABAxefWjvOsMVvFBw',
                reportFields: {
                    'Complete name': 'name',
                    'City': 'city',
                    'Telephone': 'phone.mobile',
                },
                dialogImg: false,
                imagePath: "",
                dialogErrorExist: false,
                encryptReport: false
            };
        },
        methods: {
            cleanData() {
                this.$refs.form.reset();
                this.covid = new Covid();
                this.valid = false;
                this.dialog = false;
                this.covidEntity = new CovidEntity()
            },
            newCovid() {
                this.editedIndex = -1;
                this.valid = false;
                this.dialog = true;
                this.$refs.form.reset();
                this.covid = new Covid();
                this.covidEntity = new CovidEntity()

            },
            saveData() {
                if (this.$refs.form.validate()) {
                    if (this.editedIndex > -1) {
                        this.covidEntity.value = JSON.stringify(this.covid)
                        this.covidEntity.date = this.covid.fecha
                        this.covidEntity.identification = this.covid.identification
                        this.covidEntity.id = this.covid.id
                        this.covidEntity.email = this.covid.email
                        this.covidEntity.name = this.covid.lista[0].datos[1].descripcion + " " + this.covid.lista[0].datos[2].descripcion
                        this.covidEntity.phone = this.covid.lista[0].datos[11].descripcion
                        this.covidEntity.uniqueCode = this.getUniqueCode(this.covidEntity.identification)
                        this.covidEntity.companyEntity = this.covid.lista[0].datos[5].valor
                        if (this.covid.lista[0].datos[5].valor != '') {
                            this.covidEntity.company = this.covid.lista[0].datos[5].valor.name
                        } else {
                            this.covidEntity.company = this.covid.lista[0].datos[5].descripcion
                        }
                        this.$store.dispatch('updateCovid', this.covidEntity).then(
                            response => {
                                this.cleanData();
                                this.reloadData()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    } else {
                        this.covidEntity.value = JSON.stringify(this.covid)
                        this.covidEntity.date = new Date()
                        this.covidEntity.identification = this.covid.identification
                        this.covidEntity.email = this.covid.email
                        this.covidEntity.name = this.covid.lista[0].datos[1].descripcion + " " + this.covid.lista[0].datos[2].descripcion
                        this.covidEntity.company = this.covid.lista[0].datos[5].descripcion
                        this.covidEntity.companyEntity = this.covid.lista[0].datos[5].valor
                        if (this.covid.lista[0].datos[5].valor != '') {
                            this.covidEntity.company = this.covid.lista[0].datos[5].valor.name
                        } else {
                            this.covidEntity.company = this.covid.lista[0].datos[5].descripcion
                        }
                        this.covidEntity.phone = this.covid.lista[0].datos[11].descripcion
                        this.covidEntity.uniqueCode = this.getUniqueCode(this.covidEntity.identification)
                        this.$store.dispatch('addCovid', this.covidEntity).then(
                            response => {
                                this.cleanData();
                                this.reloadData()
                            },
                            error => {
                                this.$store.state.progress = false;
                                this.$store.state.dialogError = true;
                            }
                        );
                    }
                    this.dialog = false;
                } else {
                    this.dialogErrorExist = true
                }
            },
            editItem(item) {
                this.editedIndex = this.covidListSearch.indexOf(item);
                this.$store.dispatch('getCovidOne', this.covidList[this.editedIndex].id).then(response => {
                    this.covid = JSON.parse(response.value)
                    //Se añade nuevas funcionalidades a anteriores json
                    if (this.covid.lista[0].datos.length == 21) {
                        this.covid.lista[0].datos.push(
                            {
                                valor: "",
                                descripcion: "",
                                tipo: 2,
                                label: "m. ¿Actualmente estoy en tele trabajo desde casa?",
                                data: ["SI", "NO", "SIN REFERENCIA"],
                                label2: "¿Tiempo?",
                                data2: ["Tiempo completo", "Tiempo parcial"],
                                valor2: ""
                            },
                        )
                    }
                    //Se añade nuevas funcionalidades a anteriores json
                    if (this.covid.lista.length == 7) {
                        this.covid.lista.push({
                            encabezado: "8. Estado de paciente",
                            datos: [
                                {
                                    valor1: false,
                                    valor2: false,
                                    valor3: false,
                                    valor4: false,
                                    valor5: false,
                                    valor6: false,
                                    descripcion: "",
                                    tipo: 6
                                },
                            ]
                        },)
                    }
                    if (this.covid.lista.length == 8) {
                        this.covid.lista.push({
                            encabezado: "9. Secuelas",
                            datos: [
                                {valor: "", descripcion: "", tipo: 0, label: "a. Órganos, aparatos o sistemas "},
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "CARDIOVASCULAR",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "RESPIRATORIO",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "GASTRO INTESTINAL",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "RENAL",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "NEUROLÓGICO",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "ENDOCRINO",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                                {
                                    valor: false,
                                    descripcion: "",
                                    tipo: 5,
                                    label: "Otros",
                                    label2: "Especificar",
                                    valor2: ""
                                },
                            ]
                        },)
                    }

                    //Se añade nuevas funcionalidades a anteriores json
                    if (this.covid.lista.length == 8) {
                        if (this.covid.lista[7].datos[0].valor6 == null) {
                            this.covid.lista[7].datos[0].valor6 = false
                        }
                    }
                    //Se añade nuevas funcionalidades a anteriores json
                    if (this.covid.lista[5].datos.length == 7) {
                        this.covid.lista[5].datos.push({valor: false, descripcion: "", tipo: 5, label: "h. Otro"})
                        this.covid.lista[5].datos.push({valor: false, descripcion: "", tipo: 8, label: "i. Ninguno"})
                    }
                    //Se añade nuevas funcionalidades a anteriores json
                    if (this.covid.lista[6].datos.length == 6) {
                        this.covid.lista[6].datos.push({valor: false, descripcion: "", tipo: 5, label: "h. Otro"})
                        this.covid.lista[6].datos.push({valor: false, descripcion: "", tipo: 8, label: "i. Ninguno"})
                    }

                    this.covid.identification = response.identification
                    this.covid.email = response.email
                    this.covid.id = response.id
                    this.covid.fecha = response.date
                    if (this.covid.latitude != null) {
                        this.createMap();
                    }
                    this.dialog = true;
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })

            },
            deleteItem(item) {
                this.editedIndex = this.covidListSearch.indexOf(item);
                this.covidEntity = this.covidList[this.editedIndex]
                confirm('Está seguro de que quiere eliminar el registro?') &&
                this.$store.dispatch('deleteCovid', this.covidEntity.id).then(response => {
                    this.reloadData()
                }, error => {
                    this.$store.state.progress = false;
                    this.$store.state.dialogError = true;
                })
            },
            getCovidTracer(item) {
                this.editedIndex = this.covidListSearch.indexOf(item);
                this.covidEntity = this.covidList[this.editedIndex]
                this.$store.state.covid = this.covidEntity
                this.$router.push({name: 'covidTracer'});

            },
            changeStatus(number) {
                switch (number) {
                    case 1:
                        this.covid.lista[7].datos[0].valor4 = false
                        this.covid.lista[7].datos[0].valor5 = false
                        this.covid.lista[7].datos[0].valor6 = false
                        break;
                    case 2:
                        this.covid.lista[7].datos[0].valor4 = false
                        this.covid.lista[7].datos[0].valor5 = false
                        this.covid.lista[7].datos[0].valor6 = false
                        break;
                    case 3:
                        this.covid.lista[7].datos[0].valor4 = false
                        this.covid.lista[7].datos[0].valor5 = false
                        this.covid.lista[7].datos[0].valor6 = false
                        break;
                    case 4:
                        this.covid.lista[7].datos[0].valor1 = false
                        this.covid.lista[7].datos[0].valor2 = false
                        this.covid.lista[7].datos[0].valor3 = false
                        this.covid.lista[7].datos[0].valor4 = true
                        this.covid.lista[7].datos[0].valor5 = false
                        this.covid.lista[7].datos[0].valor6 = false
                        break;
                    case 5:
                        this.covid.lista[7].datos[0].valor1 = false
                        this.covid.lista[7].datos[0].valor2 = false
                        this.covid.lista[7].datos[0].valor3 = false
                        this.covid.lista[7].datos[0].valor4 = false
                        this.covid.lista[7].datos[0].valor5 = true
                        this.covid.lista[7].datos[0].valor6 = false
                        break;
                    case 6:
                        this.covid.lista[7].datos[0].valor1 = false
                        this.covid.lista[7].datos[0].valor2 = false
                        this.covid.lista[7].datos[0].valor3 = false
                        this.covid.lista[7].datos[0].valor4 = false
                        this.covid.lista[7].datos[0].valor5 = false
                        this.covid.lista[7].datos[0].valor6 = true

                        break;
                }

            },
            reloadData() {
                this.$store.dispatch('getAllCovidsByCompany', false).then(
                    response => {
                        this.covidList = []
                        this.covidListSearch = []

                        for (let i = 0; i < this.$store.state.covidList.length; i++) {
                            let anam = {}
                            anam.id = this.$store.state.covidList[i].id
                            anam.identification = this.$store.state.covidList[i].identification
                            anam.email = this.$store.state.covidList[i].email
                            anam.company = this.$store.state.covidList[i].company
                            anam.name = this.$store.state.covidList[i].name
                            anam.phone = this.$store.state.covidList[i].phone
                            anam.date = this.getFormattedDate(this.$store.state.covidList[i].date)
                            let data = {
                                id: anam.id,
                                nombre: anam.name,
                                identificacion: anam.identification,
                                edad: "",
                                sexo: "",
                                empresa: anam.company,
                                fecha: anam.date,
                                telefono: anam.phone,
                                codigoUnico: this.$store.state.covidList[i].uniqueCode

                            }
                            this.covidListSearch.push(data)
                            this.covidList.push(anam)
                        }
                        this.$store.state.progress = false;
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
            },

            createMap() {
                mapboxgl.accessToken = this.access_token
                let map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/dark-v10',
                    center: [this.covid.longitude, this.covid.latitude],
                    zoom: 14
                })
                let geojson = {
                    type: 'FeatureCollection',
                    features: [{
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [this.covid.longitude, this.covid.latitude]
                        },
                        properties: {
                            title: 'Mapbox',
                            description: 'Paciente'
                        }
                    }]
                };
                geojson.features.forEach(function (marker) {

                    // create a HTML element for each feature
                    let el = document.createElement('div');
                    //el.className = 'marker';
                    el.style.backgroundColor = 'red';
                    el.style.backgroundSize = 'cover'
                    el.style.width = '25px'
                    el.style.height = '25px'
                    el.style.borderRadius = '50%'
                    el.style.cursor = 'pointer'

                    // make a marker for each feature and add to the map
                    new mapboxgl.Marker(el)
                        .setLngLat(marker.geometry.coordinates)
                        .addTo(map);
                });


            },
            async getCovidReport() {
                this.$store.state.progress = true;
                var reportList = [];
                await this.$store.dispatch('getAllCovidsByCompanyResolve', true).then(
                    response => {
                        for (let i = 0; i < response.data.length; i++) {
                            let covidInfo = JSON.parse(response.data[i].value);
                            var covidAux = new Object();
                            if (this.encryptReport) {
                                covidAux.CODIGO_UNICO = this.getUniqueCode(response.data[i].identification);
                            } else {
                                covidAux.EMAIL = response.data[i].email;
                                covidAux.IDENTIFICACION = response.data[i].identification;
                                covidAux.APELLIDOS = covidInfo.lista[0].datos[1].descripcion;
                                covidAux.NOMBRES = covidInfo.lista[0].datos[2].descripcion;
                            }
                            covidAux.FECHA = this.getOnlyeDate(response.data[i].date);
                            covidAux.HORA = this.getOnlyHour(response.data[i].date);
                            covidAux.EDAD = covidInfo.lista[0].datos[3].descripcion;
                            covidAux.SEXO = covidInfo.lista[0].datos[4].valor;
                            covidAux.ESTA_EMBARAZADA = covidInfo.lista[0].datos[4].valor2;
                            if (covidInfo.lista[0].datos[5].descripcion == '') {
                                let company = covidInfo.lista[0].datos[5].valor
                                covidAux.EMPRESA = company.name
                            } else {
                                covidAux.EMPRESA = covidInfo.lista[0].datos[5].descripcion
                            }
                            //covidAux.seccion1f = covidInfo.lista[0].datos[5].descripcion;
                            covidAux.CIUDAD = covidInfo.lista[0].datos[6].descripcion;
                            covidAux.CIUDAD_DOMICILIO = covidInfo.lista[0].datos[8].descripcion;
                            covidAux.CALLE = covidInfo.lista[0].datos[9].descripcion;
                            covidAux.NUMERO = covidInfo.lista[0].datos[10].descripcion;
                            covidAux.TELEF = covidInfo.lista[0].datos[11].descripcion;
                            covidAux.CARGO = covidInfo.lista[0].datos[12].descripcion;
                            covidAux.INSERCION = covidInfo.lista[0].datos[13].valor;
                            if (covidInfo.lista[0].datos.length == 17) {
                                covidAux.TURNO = covidInfo.lista[0].datos[14].valor;
                                covidAux.No_COMPANEROS = covidInfo.lista[0].datos[15].descripcion;
                                covidAux.TELETRABAJO = "";
                                covidAux.TELETRABAJO_TIEMPO = "";
                            } else {
                                let turno = ""
                                if (covidInfo.lista[0].datos[15].valor == true && covidInfo.lista[0].datos[15].label == 'Matutino') {
                                    turno = turno + ' ' + 'Matutino'
                                }
                                if (covidInfo.lista[0].datos[16].valor == true && covidInfo.lista[0].datos[16].label == 'Vespertino') {
                                    turno = turno + ' ' + 'Vespertino'
                                }
                                if (covidInfo.lista[0].datos[17].valor == true && covidInfo.lista[0].datos[17].label == 'Nocturno') {
                                    turno = turno + ' ' + 'Nocturno'
                                }
                                if (covidInfo.lista[0].datos[18].valor == true && covidInfo.lista[0].datos[18].label == 'Rotativo') {
                                    turno = turno + ' ' + 'Rotativo'
                                }
                                covidAux.TURNO = turno;
                                covidAux.No_COMPANEROS = covidInfo.lista[0].datos[19].descripcion;
                                covidAux.DESPLAZAMIENTO = covidInfo.lista[0].datos[20].valor;
                                covidAux.DESPLAZAMIENTO_OTRO = covidInfo.lista[0].datos[20].valor2;
                                if (covidInfo.lista[0].datos[21] != null) {
                                    covidAux.TELETRABAJO = covidInfo.lista[0].datos[21].valor;
                                    covidAux.TELETRABAJO_TIEMPO = covidInfo.lista[0].datos[21].valor2;
                                } else {
                                    covidAux.TELETRABAJO = "";
                                    covidAux.TELETRABAJO_TIEMPO = "";
                                }
                            }
                            covidAux.CONTACTOS = covidInfo.lista[1].datos[0].valor;
                            covidAux.CONTACTOS_ESPECIFIQUE1 = covidInfo.lista[1].datos[0].valor2;
                            covidAux.CONTACTOS_ESPECIFIQUE2 = covidInfo.lista[1].datos[0].valor3;
                            covidAux.COMPANERO_COVID = covidInfo.lista[1].datos[1].valor;
                            covidAux.FAMILIAR_COVI = covidInfo.lista[1].datos[2].valor;
                            covidAux.FAMILIAR_COVI_ESPECIFIQUE1 = covidInfo.lista[1].datos[2].valor2;
                            covidAux.FAMILIAR_COVI_ESPECIFIQUE2 = covidInfo.lista[1].datos[2].valor3;
                            covidAux.CONT_EXT = covidInfo.lista[1].datos[3].valor;
                            covidAux.EXPO_INDIRECTA_MEDIOS = covidInfo.lista[1].datos[4].valor;
                            covidAux.EXPO_DIRECTA = covidInfo.lista[1].datos[5].valor;
                            //covidAux.seccion2g = covidInfo.lista[1].datos[6].valor;
                            //covidAux.seccion2h = covidInfo.lista[1].datos[7].valor;
                            //covidAux.seccion2i = covidInfo.lista[1].datos[8].valor;

                            covidAux.USA_UNIF = covidInfo.lista[2].datos[0].valor;
                            covidAux.LAVAR_CASA = covidInfo.lista[2].datos[0].valor2;
                            //covidAux.seccion3c = covidInfo.lista[2].datos[0].valor;
                            covidAux.EPP_N95 = covidInfo.lista[2].datos[2].valor;
                            covidAux.EPP_MASC_DESCAR = covidInfo.lista[2].datos[3].valor;
                            covidAux.EPP_MASC_QUIRUR = covidInfo.lista[2].datos[4].valor;
                            covidAux.EPP_GAFAS = covidInfo.lista[2].datos[5].valor;
                            covidAux.EPP_CARETA = covidInfo.lista[2].datos[6].valor;
                            covidAux.EPP_GUANTES = covidInfo.lista[2].datos[7].valor;
                            covidAux.EPP_ZAPATOS = covidInfo.lista[2].datos[8].valor;
                            covidAux.BANO_TRABAJO = covidInfo.lista[2].datos[9].valor;
                            covidAux.AGUA_Y_JABON = covidInfo.lista[2].datos[10].valor;
                            covidAux.TOALLAS = covidInfo.lista[2].datos[11].valor;
                            //covidAux.seccion3d = covidInfo.lista[2].datos[0].valor;
                            covidAux.VENTILACION = covidInfo.lista[2].datos[13].valor;
                            covidAux.LIMPIEZA_HERRAMIENTAS = covidInfo.lista[2].datos[14].valor;
                            covidAux.LIMPIEZA_PISOS = covidInfo.lista[2].datos[15].valor;
                            covidAux.LIMPIEZA_MOBILIARIO = covidInfo.lista[2].datos[16].valor;
                            covidAux.DISPOSICION_DESECHOS = covidInfo.lista[2].datos[17].valor;
                            covidAux.TUNEL = covidInfo.lista[2].datos[18].valor;
                            covidAux.BANDEJA_DESI = covidInfo.lista[2].datos[19].valor;
                            covidAux.DIFU_ENFER = covidInfo.lista[2].datos[20].valor;
                            covidAux.DIFU_MED_PROTEC = covidInfo.lista[2].datos[21].valor;
                            covidAux.DIFU_AISLA = covidInfo.lista[2].datos[22].valor;

                            covidAux.FUMA = covidInfo.lista[3].datos[0].valor;
                            //covidAux.seccion4b = covidInfo.lista[3].datos[1].valor;
                            covidAux.GRIPE = covidInfo.lista[3].datos[2].valor;
                            covidAux.ENFISEMA = covidInfo.lista[3].datos[3].valor;
                            covidAux.TUBERC = covidInfo.lista[3].datos[4].valor;
                            covidAux.ASMA = covidInfo.lista[3].datos[5].valor;
                            covidAux.BRONQUITIS = covidInfo.lista[3].datos[6].valor;
                            covidAux.RINITIS_AL = covidInfo.lista[3].datos[7].valor;
                            covidAux.HTA = covidInfo.lista[3].datos[8].valor;
                            covidAux.DIAB = covidInfo.lista[3].datos[9].valor;
                            covidAux.OTRAS = covidInfo.lista[3].datos[10].valor;
                            covidAux.OTRAS_SI = covidInfo.lista[3].datos[10].valor2;
                            //covidAux.seccion4c = covidInfo.lista[3].datos[2].valor;
                            covidAux.TOS = covidInfo.lista[3].datos[12].valor;
                            covidAux.DOLOR_GAR = covidInfo.lista[3].datos[13].valor;
                            covidAux.EXPEC = covidInfo.lista[3].datos[14].valor;
                            covidAux.ESTORNUDO = covidInfo.lista[3].datos[15].valor;
                            covidAux.DISNEA = covidInfo.lista[3].datos[16].valor;
                            covidAux.RINORREA = covidInfo.lista[3].datos[17].valor;
                            covidAux.FIEBRE = covidInfo.lista[3].datos[18].valor;
                            //covidAux.seccion4cviii = covidInfo.lista[3].datos[10].valor;
                            //covidAux.seccion4cix = covidInfo.lista[3].datos[11].valor;
                            //covidAux.seccion4cx = covidInfo.lista[3].datos[11].valor2;
                            covidAux.PCR_RT = covidInfo.lista[3].datos[19].valor;
                            covidAux.PCR_RT_RESULTADO = covidInfo.lista[3].datos[19].valor2;
                            //covidAux.seccion4dii = covidInfo.lista[3].datos[21].valor;
                            //covidAux.seccion4diii = covidInfo.lista[3].datos[22].valor;
                            //covidAux.seccion4div = covidInfo.lista[3].datos[23].valor;
                            //covidAux.seccion4dv = covidInfo.lista[3].datos[24].valor;
                            //covidAux.seccion4dvi = covidInfo.lista[3].datos[25].valor;
                            //covidAux.seccion4dvii = covidInfo.lista[3].datos[19].valor;
                            covidAux.P_RAPIDA = covidInfo.lista[3].datos[20].valor;
                            covidAux.P_RAPIDA_RESULTADO = covidInfo.lista[3].datos[20].valor2;
                            covidAux.RX_TORAX = covidInfo.lista[3].datos[21].valor;
                            covidAux.RX_TORAX_RESULTADO = covidInfo.lista[3].datos[21].valor2;
                            covidAux.TAC = covidInfo.lista[3].datos[22].valor;
                            //covidAux.seccion4gresultado = covidInfo.lista[3].datos[22].valor2;
                            covidAux.LAB = covidInfo.lista[3].datos[23].valor;
                            //covidAux.seccion4i = covidInfo.lista[3].datos[24].valor;

                            covidAux.CATEG_OMS_SANO = 'NO';
                            covidAux.CATEG_OMS_SOSPECHOSO = 'NO';
                            covidAux.CATEG_OMS_PROBABLE = 'NO';
                            covidAux.CATEG_OMS_CONFIRMADO = 'NO';
                            covidAux.CATEG_OMS_OTRO = 'NO';
                            if (covidInfo.lista[4].datos[0].valor == 'a. Trabajador sano') {
                                covidAux.CATEG_OMS_SANO = 'SI'
                            } else if (covidInfo.lista[4].datos[0].valor == 'b. Caso sospechoso') {
                                covidAux.CATEG_OMS_SOSPECHOSO = 'SI'
                            } else if (covidInfo.lista[4].datos[0].valor == 'c. Caso probable') {
                                covidAux.CATEG_OMS_PROBABLE = 'SI'
                            } else if (covidInfo.lista[4].datos[0].valor == 'd. Caso confirmado') {
                                covidAux.CATEG_OMS_CONFIRMADO = 'SI'
                            } else if (covidInfo.lista[4].datos[0].valor == 'e. Otro síndrome respiratorio distinto a CoViD-19') {
                                covidAux.CATEG_OMS_OTRO = 'SI'
                            }


                            covidAux.RECOMEND_SALUD_LAB_GAB = covidInfo.lista[5].datos[0].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_AISL_OPORT = covidInfo.lista[5].datos[1].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_SEG_MON_EPID_REG = covidInfo.lista[5].datos[2].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_MSP_IESS = covidInfo.lista[5].datos[3].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_GUIAS_PROT = covidInfo.lista[5].datos[4].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_GUIAS_PROT_ESPECIFICAR = covidInfo.lista[5].datos[4].valor2;
                            covidAux.RECOMEND_SALUD_MAT_DIF = covidInfo.lista[5].datos[5].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_SALUD_INF_SERV_SALUD = covidInfo.lista[5].datos[6].valor ? 'SI' : 'NO';

                            if (covidInfo.lista[5].datos[7] != null) {
                                covidAux.RECOMEND_SALUD_OTRO = covidInfo.lista[5].datos[7].valor ? 'SI' : 'NO';
                                covidAux.RECOMEND_SALUD_OTRO_ESPECIFICAR = covidInfo.lista[5].datos[7].valor3;
                                covidAux.RECOMEND_SALUD_NINGUNO = covidInfo.lista[5].datos[8].valor ? 'SI' : 'NO';
                            } else {
                                covidAux.RECOMEND_SALUD_OTRO = "";
                                covidAux.RECOMEND_SALUD_OTRO_ESPECIFICAR = "";
                                covidAux.RECOMEND_SALUD_NINGUNO = "";
                            }


                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_MED_PROTEC_COLEC = covidInfo.lista[6].datos[0].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_MED_PROTEC_COLEC_ESPECIFICAR1 = covidInfo.lista[6].datos[0].valor2;
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_MED_PROTEC_COLEC_ESPECIFICAR2 = covidInfo.lista[6].datos[0].valor3;
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_CAMB_ORG = covidInfo.lista[6].datos[1].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_EVIT_ACT_MAS = covidInfo.lista[6].datos[2].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_EVIT_REUN_GRUP = covidInfo.lista[6].datos[3].valor ? 'SI' : 'NO';
                            covidAux.RECOMEND_COND_TRABAJO_Y_FAMIL_TELETRAB = covidInfo.lista[6].datos[4].valor ? 'SI' : 'NO';
                            if (covidInfo.lista[6].datos[6] != null) {
                                covidAux.RECOMEND_COND_TRABAJO_Y_OTRO = covidInfo.lista[6].datos[6].valor ? 'SI' : 'NO';
                                covidAux.RECOMEND_COND_TRABAJO_Y_OTRO_ESPECIFICAR = covidInfo.lista[6].datos[6].valor3;
                                covidAux.RECOMEND_COND_TRABAJO_Y_NINGUNO = covidInfo.lista[6].datos[7].valor ? 'SI' : 'NO';
                            } else {
                                covidAux.RECOMEND_COND_TRABAJO_Y_OTRO = "";
                                covidAux.RECOMEND_COND_TRABAJO_Y_OTRO_ESPECIFICAR = "";
                                covidAux.RECOMEND_COND_TRABAJO_Y_NINGUNO = "";
                            }


                            //covidAux.seccion7f = covidInfo.lista[6].datos[5].valor;

                            covidAux.EST_PAC_OBSERVACION = covidInfo.lista[7].datos[0].valor1 ? 'SI' : 'NO';
                            covidAux.EST_PAC_CONFIRMADO = covidInfo.lista[7].datos[0].valor2 ? 'SI' : 'NO';
                            covidAux.EST_PAC_HOSPITALIZADO = covidInfo.lista[7].datos[0].valor3 ? 'SI' : 'NO';
                            covidAux.EST_PAC_RECUPERADO = covidInfo.lista[7].datos[0].valor4 ? 'SI' : 'NO';
                            covidAux.EST_PAC_FALLECIDO = covidInfo.lista[7].datos[0].valor5 ? 'SI' : 'NO';

                            if (covidInfo.lista[8] != null && covidInfo.lista[8].datos[1] != null && covidInfo.lista[8].datos[2] != null && covidInfo.lista[8].datos[3] != null && covidInfo.lista[8].datos[4] != null && covidInfo.lista[8].datos[5] != null && covidInfo.lista[8].datos[6] != null && covidInfo.lista[8].datos[7] != null) {
                                covidAux.SECUELAS_SISTEMA_CARDIOVASCULAR = covidInfo.lista[8].datos[1].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_CARDIOVASCULAR_ESPECIFIQUE = covidInfo.lista[8].datos[1].valor3;
                                covidAux.SECUELAS_SISTEMA_RESPIRATORIO = covidInfo.lista[8].datos[2].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_RESPIRATORIO_ESPECIFIQUE = covidInfo.lista[8].datos[2].valor3;
                                covidAux.SECUELAS_SISTEMA_GASTRO_INTESTINAL = covidInfo.lista[8].datos[3].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_GASTRO_INTESTINAL_ESPECIFIQUE = covidInfo.lista[8].datos[3].valor3;
                                covidAux.SECUELAS_SISTEMA_RENAL = covidInfo.lista[8].datos[4].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_RENAL_ESPECIFIQUE = covidInfo.lista[8].datos[4].valor3;
                                covidAux.SECUELAS_SISTEMA_NEUROLOGICO = covidInfo.lista[8].datos[5].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_NEUROLOGICO_ESPECIFIQUE = covidInfo.lista[8].datos[5].valor3;
                                covidAux.SECUELAS_SISTEMA_ENDOCRINO = covidInfo.lista[8].datos[6].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_ENDOCRINO_ESPECIFIQUE = covidInfo.lista[8].datos[6].valor3;
                                covidAux.SECUELAS_SISTEMA_OTRO = covidInfo.lista[8].datos[7].valor ? 'SI' : 'NO';
                                covidAux.SECUELAS_SISTEMA_OTRO_ESPECIFIQUE = covidInfo.lista[8].datos[7].valor3;
                            } else {
                                covidAux.SECUELAS_SISTEMA_CARDIOVASCULAR = "";
                                covidAux.SECUELAS_SISTEMA_CARDIOVASCULAR_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_RESPIRATORIO = "";
                                covidAux.SECUELAS_SISTEMA_RESPIRATORIO_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_GASTRO_INTESTINAL = "";
                                covidAux.SECUELAS_SISTEMA_GASTRO_INTESTINAL_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_RENAL = "";
                                covidAux.SECUELAS_SISTEMA_RENAL_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_NEUROLOGICO = "";
                                covidAux.SECUELAS_SISTEMA_NEUROLOGICO_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_ENDOCRINO = "";
                                covidAux.SECUELAS_SISTEMA_ENDOCRINO_ESPECIFIQUE = "";
                                covidAux.SECUELAS_SISTEMA_OTRO = "";
                                covidAux.SECUELAS_SISTEMA_OTRO_ESPECIFIQUE = "";
                            }

                            reportList.push(covidAux);
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
                if (reportList.length == 0) {
                    alert('No existen registros.');
                }
                this.$store.state.progress = false;
                return reportList;
            },
            async getCovidTraceReport() {
                this.$store.state.progress = true;
                var reportList = [];
                await pause(2000);
                this.$store.dispatch('getAllCovidsByCompanyResolve', false).then(
                    response1 => {
                        for (let i = 0; i < response1.data.length; i++) {
                            let covidInfo = response1.data[i];
                            this.$store.dispatch('getCovidTraceListByCovidIdResolve', covidInfo.id).then(
                                response2 => {
                                    for (let j = 0; j < response2.data.length; j++) {
                                        let covidTrace = JSON.parse(response2.data[j].value);
                                        for (let k = 0; k < covidTrace.length; k++) {
                                            var covidAux = new Object();
                                            if (this.encryptReport) {
                                                covidAux.CODIGO_UNICO = this.getUniqueCode(covidInfo.identification);
                                            } else {
                                                covidAux.EMAIL = covidInfo.email;
                                                covidAux.IDENTIFICACION = covidInfo.identification;
                                            }
                                            covidAux.PREGUNTA = covidTrace[k].pregunta;
                                            covidAux.RESPUESTA = covidTrace[k].respuesta;
                                            covidAux.FECHA = this.getOnlyeDate(response2.data[j].date);
                                            covidAux.HORA = this.getOnlyHour(response2.data[j].date);
                                            reportList.push(covidAux);
                                        }
                                    }
                                },
                                error => {
                                    this.$store.state.dialogError = true;
                                }
                            );
                        }
                    },
                    error => {
                        this.$store.state.dialogError = true;
                    }
                );
                await pause(500);
                if (reportList.length == 0) {
                    alert('No existen registros.');
                }
                this.$store.state.progress = false;
                return reportList;
            },

            getLastCovidRegister() {
                if (this.editedIndex = -1) {
                    // Si existe, verifica que se ecuentre Inactivo las alarmas para generar uno nuevo.
                    this.$store.dispatch('lastCovid', this.covid.identification).then(
                        response => {
                            if (response.data != "") {
                                this.covid = JSON.parse(response.data.value);
                                this.covid.identification = response.data.identification
                                this.covid.email = response.data.email
                                this.covid.company = response.data.company
                                this.covid.name = response.data.name
                            } else {
                                //this.covid = new Covid();
                                this.covidEntity = new CovidEntity()
                            }
                        }
                    )
                }
            },

            getFormattedDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (true) {
                    // Para Safari
                    if (!(dateReg instanceof Date)) {
                        var b = dateReg.toString().split(/\D/);
                        date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                    } else {
                        date = new Date(dateReg);
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
                return str;
            },

            getOnlyeDate(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Para chrome
                        date = new Date(dateReg);
                    } else {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var month = date.getMonth() + 1;
                var day = date.getDate();
                month = (month < 10 ? "0" : "") + month;
                day = (day < 10 ? "0" : "") + day;
                var str = date.getFullYear() + "-" + month + "-" + day;
                return str;
            },

            getOnlyHour(dateReg) {
                var ua = navigator.userAgent.toLowerCase();
                var date;
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        // Para chrome
                        date = new Date(dateReg);
                    } else {
                        // Para Safari
                        if (!(dateReg instanceof Date)) {
                            var b = dateReg.toString().split(/\D/);
                            date = new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5]));
                        } else {
                            date = new Date(dateReg);
                        }
                    }
                } else {
                    // Otros navegadores
                    date = new Date(dateReg);
                }
                var hour = date.getHours();
                var min = date.getMinutes();
                var sec = date.getSeconds();
                hour = (hour < 10 ? "0" : "") + hour;
                min = (min < 10 ? "0" : "") + min;
                sec = (sec < 10 ? "0" : "") + sec;
                var str = hour + ":" + min + ":" + sec;
                return str;
            },

            showImageDialog(img) {
                this.dialogImg = true;
                if (img === "img5") {
                    this.imagePath = "img5";
                } else if (img === "img6") {
                    this.imagePath = "img6";
                }
            },
            getUniqueCode(data) {
                let hashString = sha(data)
                let responseUniqueCode = hashString.substr(0, 10) + hashString.substr(59)
                return responseUniqueCode.toUpperCase()
            },
            permitOnlyNumbers: function ($event) {
                var tecla = $event.charCode;
                if (tecla === 8) {
                    return true
                } else {
                    // Patron de entrada, en este caso solo acepta numeros
                    const patron = /[0-9]/;
                    var tecla_final = String.fromCharCode(tecla);
                    if (!patron.test(tecla_final)) {
                        $event.preventDefault();
                    }
                }
            }
        },
        computed: {},
        created() {
            this.reloadData();
            this.$store.dispatch('getCompanies').then(response => {
            }, error => {
                this.$store.state.dialogError = true
            })

            this.$store.dispatch('getCovidConfiguration').then(
                response => {
                    if (response.data.id != null) {
                        this.covidConfiguration = response.data;
                        if (this.covidConfiguration.encryptReport == 'SI') {
                            this.encryptReport = true
                        }else{
                            this.encryptReport = false
                        }
                    }
                },
                error => {
                    this.$store.state.dialogError = true;
                }
            );
        }
    };
</script>

<style scoped>
    #map {
        top: 0;
        bottom: 0;
        width: 100%;
        height: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/components/covid/Covid.vue